const headers = {
  name: "Teams",
  navigate: {
    path: [
      {
        name: "Teams",
        path: "/app/contacts/teams",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
